import { render } from "./Invoice.vue?vue&type=template&id=1ba9b007&scoped=true&ts=true"
import script from "./Invoice.vue?vue&type=script&lang=ts"
export * from "./Invoice.vue?vue&type=script&lang=ts"

import "./Invoice.vue?vue&type=style&index=0&id=1ba9b007&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ba9b007"]])

export default __exports__